import { render, staticRenderFns } from "./FinishWholesaleOrder.vue?vue&type=template&id=3866e5f8"
import script from "./FinishWholesaleOrder.vue?vue&type=script&lang=js"
export * from "./FinishWholesaleOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports